import React, { memo } from 'react'
import { useTab, TabProps } from './useTab'
import styles from './Tab.module.scss'

const Tab: React.FC<TabProps> = (props: TabProps) => {
  const { id, name, isActive, handleClick } = useTab(props)

  return (
    <span
      className={`${styles.tab} ${isActive ? styles.active : ''}`}
      onClick={() => handleClick(id)}
    >
      #{name}
    </span>
  )
}

export default memo(Tab)
